var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"version-edit"},[_c('edit',{attrs:{"fs":_vm.versionFields,"api":"versions","id":_vm.id,"title":"Version"},on:{"saved":_vm.saved}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }